import { Link } from "react-router-dom";
import { useSEO } from "@/hooks/useSEO";
import { newsList, getFeaturedNews } from "@/mocks/news";
import { worksList } from "@/mocks/works";
import { profileData } from "@/mocks/profile";
import HeroCarousel from "./components/HeroCarousel";
import CategoryEntries from "./components/CategoryEntries";
import HomeSidebar from "./components/HomeSidebar";
import NewsCard from "@/components/feature/NewsCard";
import WorkCard from "@/components/feature/WorkCard";
import SectionHeading from "@/components/feature/SectionHeading";

export default function Home() {
  useSEO({
    title: "小泽玛利亚 - 明星资讯与最新动态大全",
    description:
      "小泽玛利亚官方网站，提供她的详细个人资料、最新新闻、作品动态及相关资讯，满足粉丝对偶像的全面了解需求。",
    keywords: "小泽玛利亚,明星资讯,个人资料,最新动态,影视作品,偶像新闻,粉丝平台",
  });

  const featured = getFeaturedNews();
  const latestNews = [...newsList].sort((a, b) => b.date.localeCompare(a.date)).slice(0, 6);
  const recommendedWorks = [...worksList].sort((a, b) => b.year - a.year).slice(0, 4);

  return (
    <div className="animate-fade-up">
      <section className="mx-auto max-w-content px-4 md:px-6 pt-6 md:pt-8">
        <HeroCarousel items={featured} />
      </section>

      <section className="mx-auto max-w-content px-4 md:px-6 mt-12 md:mt-16">
        <SectionHeading
          eyebrow="Explore"
          title="快速了解她的世界"
          subtitle="从最新资讯到影视作品，几个入口带你快速走进小泽玛利亚的资讯专区。"
        />
        <CategoryEntries />
      </section>

      <section className="mx-auto max-w-content px-4 md:px-6 mt-12 md:mt-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-10">
          <div className="lg:col-span-2">
            <SectionHeading
              eyebrow="News"
              title="最新资讯"
              actionText="查看全部"
              actionTo="/category/news"
            />
            <div className="flex flex-col gap-4">
              {latestNews.map((item) => (
                <NewsCard key={item.id} item={item} layout="horizontal" />
              ))}
            </div>
          </div>
          <div className="lg:col-span-1">
            <HomeSidebar />
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-content px-4 md:px-6 mt-12 md:mt-16">
        <SectionHeading
          eyebrow="Works"
          title="影视作品推荐"
          subtitle="精选近年作品，点击卡片查看作品详情与角色介绍。"
          actionText="全部作品"
          actionTo="/works"
        />
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {recommendedWorks.map((item) => (
            <WorkCard key={item.id} item={item} />
          ))}
        </div>
      </section>

      <section className="mt-14 md:mt-20">
        <div className="mx-auto max-w-content px-4 md:px-6">
          <div className="bg-primary-50 border border-primary-100 rounded-lg overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-2">
              <div className="p-6 md:p-10">
                <span className="text-xs font-medium tracking-[0.2em] text-primary-600 uppercase">
                  About The Site
                </span>
                <h2 className="font-heading text-xl md:text-3xl font-semibold text-foreground-950 mt-2 mb-4">
                  关于本站
                </h2>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  本站是一个专注小泽玛利亚的粉丝向资讯平台，聚合她的最新新闻、活动行程、生活花絮与影视作品资料，帮助粉丝更快、更全面地了解偶像动态。
                </p>
                <ul className="flex flex-col gap-3 mb-6">
                  {[
                    "实时更新她的演艺新闻与活动动态",
                    "完整收录影视作品与角色介绍",
                    "整理权威个人资料与成长时间轴",
                  ].map((text) => (
                    <li key={text} className="flex items-start gap-2 text-sm text-foreground-700">
                      <i className="ri-checkbox-circle-fill text-primary-500 mt-0.5"></i>
                      {text}
                    </li>
                  ))}
                </ul>
                <Link
                  to="/about"
                  className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  了解更多
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
              <div className="relative min-h-[240px] lg:min-h-full">
                <img
                  src={profileData.cover}
                  alt="小泽玛利亚资讯站"
                  title="小泽玛利亚明星资讯站"
                  className="absolute inset-0 w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}